import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getRemoteConfig } from "firebase/remote-config";

const firebaseConfig = {
    apiKey: "AIzaSyD5UuQN3k2LKmlT8p-_VmwS13I66byCp_s",
    authDomain: "foodzee-10dab.firebaseapp.com",
    projectId: "foodzee-10dab",
    storageBucket: "foodzee-10dab.appspot.com",
    messagingSenderId: "408711591996",
    appId: "1:408711591996:web:365cdaafdd037d3a15ab39",
    measurementId: "G-SR96XK1RGL"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const remoteConfig = getRemoteConfig(app);
remoteConfig.settings = {
    minimumFetchIntervalMillis: 0,
}

remoteConfig.defaultConfig = {
    three_day_plan: {
        "name": "3 Day Trial",
        "price": "$1",
        "discount": "$5.49",
        "text": "Then 1-Month Plan $1.33/day",
        "right_price": "$1",
        "right_text": "3 Day Trial"
    },
    one_week_plan: {
        "name": "1 Week Trial",
        "price": "$5.49",
        "discount": "$5.49",
        "text": "Then it's $9.99 a week.",
        "right_price": "$5.49",
        "right_text": "1 Week Trial"
    },
    four_week_plan: {
        "name": "4 Week Trial",
        "price": "$5.49",
        "discount": "$5.49",
        "text": "Then it's $9.99 a week.",
        "right_price": "$5.49",
        "right_text": "4 Week Trial"
    },
    with_trial: {
        weekly: "$19.99",
        billed_amount: "$19.99",
        billed_4_weeks: "$79.99",
    },
    without_trial: {
        daily: "$1.42",
        billed_amount: "$39.99",
        billed_4_weeks: "$39.99",
    },
    special_offer: {
        prev_price: "$99.99",
        offered_price: "$32.99",
        discount: '67%'
    }
};

export { app, analytics, remoteConfig };
